import { connect } from 'react-redux'

import PaymentForm from '../components/PaymentForm'
import { createPaymentAction } from '../actions/paymentActions'

const mapStateToProps = (state, props) => {
  return { }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    createPayment: (payment) => dispatch(createPaymentAction(props.organization_id, props.resident_id, payment)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentForm)
